import { Routes } from '@angular/router';

import { AuthLayoutComponent } from './modules/layouts/auth/auth-layout.component';
import { ClientesLayoutComponent } from './modules/layouts/clientes/clientes-layout.component';
import { RoleGuardService } from './services/role-guard.service';

export const AppRoutes: Routes = [{
    path: '',
    component: ClientesLayoutComponent,
    children: [{
      path: '',
      loadChildren: './clientes/action-aid/action-aid.module#ActionAidModule'
    }]
  }];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts